import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getSessionEnrollmentsActions } from '../actions';

const {
  useLoader: useRiskEvaluationSessionDataLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getSessionEnrollmentsActions,
});

function StudentRiskEvaluationSessionDataLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  StudentRiskEvaluationSessionDataLoader,
  useRiskEvaluationSessionDataLoader,
};
